import { render } from "./ApthAroundMeWidget.vue?vue&type=template&id=065e5570"
import script from "./ApthAroundMeWidget.vue?vue&type=script&lang=js"
export * from "./ApthAroundMeWidget.vue?vue&type=script&lang=js"

import "./ApthAroundMeWidget.vue?vue&type=style&index=0&id=065e5570&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__